<template>
  <span v-if="loading">
    <div
      style="width: 120px; height: 120px"
      class="d-flex align-items-center justify-content-center img-thumbnail thumb-image"
    >
      <i class="far fa-spinner-third fa-spin"></i>
    </div>
    <img :key="path" :class="{ 'd-none': loading }" @load="onLoad" @error="onError" :src="path" />
  </span>
  <img v-else class="img-thumbnail thumb-image" style="width: 120px" :src="path" />
</template>
<script>
export default {
  name: 'MImg',
  props: {
    urls: {
      type: [String]
    }
  },
  data() {
    this.urlList = [...this.urls].filter((e) => e);
    return {
      urlList: this.urlList,
      loading: true,
      path: this.urlList.shift()
    };
  },
  methods: {
    onLoad() {
      this.loading = false;
      this.$emit('load', this.path);
    },
    onError() {
      if (this.urlList.length) {
        this.path = this.urlList.shift();
      } else {
        this.loading = false;
      }
    }
  }
};
</script>
